import { render, staticRenderFns } from "./frontVendidos.vue?vue&type=template&id=a6968fce&"
import script from "./frontVendidos.vue?vue&type=script&lang=js&"
export * from "./frontVendidos.vue?vue&type=script&lang=js&"
import style0 from "./frontVendidos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports